if (!customElements.get('trust-indicators-slider')) {
  class TrustIndicatorsSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      const config = {
        watchOverflow: true,
        slidesPerView: swiperOptions.slidesPerViewMobile || 1.1,

        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        breakpoints: {
          750: {
            enabled: true,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
            slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
            loop: false,
          }
        }
      };

      const prevEl = this.querySelector('.slider-button--prev');
      const nextEl = this.querySelector('.slider-button--next');
      const counterEl = this.querySelector('.slider-counter');

      if (prevEl && nextEl) {
        config.navigation = { prevEl: prevEl, nextEl: nextEl };
      }

      if (counterEl) {
        config.pagination = { el: counterEl, type: 'fraction' };
      }

      this.slider = new Swiper(this, config);
    }
  }

  customElements.define('trust-indicators-slider', TrustIndicatorsSlider);
}
